module.exports = __webpack_public_path__ + "static/media/imagenet2.4607c876.png";